const e = "servicePage_wjtH8", a = "mainArea_rK2iV", r = "services_M4ijq", s = "serviceList_nyMXM", i = "kioskServiceWrapper_e8qXg", n = "kioskServiceWrapper__disabled_xue1D", c = "languagesContainer_e6m4d", g = "languagesWrapper_5NpJw", t = "languagesTitle_Q-XZi", p = "languageSelectorWrapper_jyY-V", o = {
  servicePage: e,
  mainArea: a,
  services: r,
  serviceList: s,
  kioskServiceWrapper: i,
  kioskServiceWrapper__disabled: n,
  languagesContainer: c,
  languagesWrapper: g,
  languagesTitle: t,
  languageSelectorWrapper: p
};
export {
  o as default,
  i as kioskServiceWrapper,
  n as kioskServiceWrapper__disabled,
  p as languageSelectorWrapper,
  c as languagesContainer,
  t as languagesTitle,
  g as languagesWrapper,
  a as mainArea,
  s as serviceList,
  e as servicePage,
  r as services
};
//# sourceMappingURL=service.module.scss.js.map
